<template>
    <div style="position: relative">
        <div class="col-xs-2" style="height: 100%; padding:0; width: 12.4%" v-show="largeScreen"
             id="threat-timeline-menu">
            <div v-show="!loading">
                <dashboard-item-menu
                    ref="threatTimeLineItemMenu"
                    :titleColor="mainTitleColor"
                    :titleBackgroundColor="mainTitleBackgroundColor"
                    :title="mainTitle"
                    :menuList="threatTimeLineMenuList"
                    @menuItemClicked="onTimelineMenuSelect"
                ></dashboard-item-menu>
                <div style="height: 3px; width: 100%">

                </div>
            </div>
        </div>
        <div class="col-xs-10" style="height: 100%; position: relative;" v-if="largeScreen"
             v-on:wheel="changeZoomLevel">
            <div class="graph-time-container" v-if="this.fetchData" v-show="!this.loading">
                <p>{{graphLabel}} </p>
            </div>
            <threat-time-line-graph v-if="this.fetchData" v-show="!this.loading" :data="this.dataForGraph"
                                    :selected-item-enum="this.selectedItemEnum" :zoomLevel="this.getZoomLevelIndex"
                                    :height="450" @dragHandler="graphDragHandler"
                                    @pointClicks="pointsClicked" ref="threatTimeLineGraph"></threat-time-line-graph>
        </div>

        <!-- Large Size Start -->
        <div v-if="!largeScreen">
            <threat-time-line-maximize :largeScreenBoolean="this.largeScreen" @renderedMaximize="renderedMaximizeValue"
            ></threat-time-line-maximize>
        </div>
        <div class="enlarge-button grow" @click="onEnlargeClick" v-show="!loading">
            <img src="../../../assets/enlarge-button.svg" class="enlarge-button-icon"/>
        </div>
        <loading-modal v-if="loading" :color="'blue'"></loading-modal>
    </div>
</template>

<script>

    import DashboardItemMenu from '@/components/menu/DashboardItemMenu.vue'
    import Common from '@/utils/Common.vue'
    import Constants from '@/utils/constants'
    import LoadingModal from "@/components/modals/LoadingModal";
    import {mapActions} from 'vuex';
    import {mapGetters} from 'vuex';

    const MENU_MAIN_TITLE_COLOR = "black";
    const MENU_MAIN_TITLE_BACKGROUND_COLOR = "#FB2C37";
    const MENU_ITEM_BACKGROUND_COLOR = "#D30022";
    const MENU_ITEM_COLOR = "rgb(63,92,111)";
    const MENU_TITLE_COLOR = "white";
    const RISK_SCORE_MENU_ITEM_TEXTS = [];
    const TOTAL_FEED_COUNT = 15;

    import ThreatTimeLineGraph from "../../../components/threat-timeline/ThreatTimeLineGraph";
    import ThreatTimeLineMaximize from "../threat-timeline/ThreatTimeLineMaximize";
    import moment from "moment-timezone";
    import constants from './../../../components/threat-timeline/const';

    export default {
        name: "threat-timeline",
        components: {
            ThreatTimeLineGraph: ThreatTimeLineGraph,
            ThreatTimeLineMaximize: ThreatTimeLineMaximize,
            DashboardItemMenu: DashboardItemMenu,
            LoadingModal: LoadingModal
        },
        props: {
            itemNumber: {
                type: Number,
                required: true
            },
            enlargeClickedThreatTimeLine: {
                type: Function,
                required: true
            }
        },
        mixins: [Common],
        data() {
            return {
                mainTitle: 'THREAT\nTIMELINE',
                mainTitleColor: MENU_MAIN_TITLE_COLOR,
                mainTitleBackgroundColor: MENU_MAIN_TITLE_BACKGROUND_COLOR,
                loading: false,
                largeScreen: true,
                enLargeClicked: null,
                threatTimeLineMenuList: [],
                categoryList: [],
                categoryMenuItems: [],
                selectedThreatTimelineCategoryItem: {},
                graphDataFromBackend: null,
                graphWeeklyDataFromBackend: null,
                selectedItemEnum: 0,
                dataForGraph: [],
                fetchData: null,
                zoomLevel: 2,
                maxRadius: 30,
                startDay: null,
                endDay: null,
                logarithmicBase: 0,
                logarithmicBaseWeekly: 0,
                renderMaximize: false,
                graphLabel: '30 days',
                zoomLevel1DayCount: 14,
                zoomLevel2DayCount: 30,
                zoomLevel3WeekCount: 12,
                zoomLevel4WeekCount: 24,
                zoomLevel5WeekCount: 48
            }
        },
        methods: {
            renderedMaximizeValue(status) {
                this.renderMaximize = status;
            },
            pointsClicked(evt, item, data) {
                this.loading = true;
                let grapData = this.graphDataFromBackend;
                if (this.selectedItemEnum === 0) {
                    if (this.zoomLevel >= 3) {
                        this.zoomLevel = 2;
                        this.setZoomLevelIndex(2);
                        this.adjustShownDates();
                    }
                    else {

                    }
                    this.changeSelectedCategory(data);
                    this.selectedItemEnum = data;
                    this.getMaxCountHelper(grapData);
                    this.setGraphData(grapData);
                }
                this.loading = false;
            },
            onTimelineMenuSelect(menuItem) {
                this.selectedThreatTimelineCategoryItem = null;
                this.$nextTick(function () {
                    this.selectedThreatTimelineCategoryItem = menuItem;
                });
                this.selectedItemEnum = menuItem.groupEnumNo;
                if (this.zoomLevel >= 3) {
                    this.getMaxCountHelper(this.graphWeeklyDataFromBackend);
                    this.setGraphData(this.graphWeeklyDataFromBackend);
                }
                else {
                    this.getMaxCountHelper(this.graphDataFromBackend);
                    this.setGraphData(this.graphDataFromBackend);
                }
            },
            changeSelectedCategory(groupEnumNo) {
                for (var i = 0; i < this.categoryMenuItems.length; i++) {
                    if (parseInt(this.categoryMenuItems[i].groupEnumNo) === parseInt(groupEnumNo)) {
                        this.categoryMenuItems[i]["selected"] = true;
                        this.selectedThreatTimelineCategoryItem = this.categoryMenuItems[i];
                    }
                    else
                        this.categoryMenuItems[i]["selected"] = false;
                }
            },
            getCategoryList() {
                this.loading = true;

                let body = {
                    risk_group_enum: this.selectedThreatTimelineCategoryItem.groupEnumNo,
                    start_day: this.startDay,
                    end_day: this.endDay
                };

                var path = Constants.INTELLIGENCE_BACKEND_URL + '/dashboard/threat_timeline_categories';
                this.$http.post(path, body).then(response => {
                    this.categoryList = response.body.data;
                    this.categoryMenuItems = [];
                    for (var i = 0; i < this.categoryList.length; i++) {
                        var item = {
                            id: this.uuidv4(),
                            groupEnumNo: this.categoryList[i].risk_group_enum_no,
                            text: this.categoryList[i].risk_group_name,
                            color: MENU_ITEM_COLOR,
                            progress: this.categoryList[i].percent,
                            progressColor: "red",
                            selectedColor: "white",
                            selected: false
                        };

                        if (this.selectedThreatTimelineCategoryItem != null) {

                        } else {
                            item["selected"] = true;
                            this.selectedThreatTimelineCategoryItem = item;
                        }
                        this.categoryMenuItems.push(item)
                    }
                    if (this.largeScreen) {
                        let isSmallScreenContains = false;
                        for (var i = 0; i < this.categoryMenuItems.length; i++) {
                            if (this.selectedThreatTimelineCategoryItem.text === this.categoryMenuItems[i].text) {
                                this.categoryMenuItems[i]["selected"] = true;
                                isSmallScreenContains = true;
                                break;
                            }
                        }
                        if (!isSmallScreenContains) {
                            if (this.categoryMenuItems.length > 0) {
                                this.categoryMenuItems[0]["selected"] = true;
                                this.selectedThreatTimelineCategoryItem = this.categoryMenuItems[0];
                            }
                        }
                    }
                    this.threatTimeLineMenuList = [
                        {
                            type: "selectableProgress",
                            text: "CATEGORY",
                            color: MENU_TITLE_COLOR,
                            backgroundColor: MENU_ITEM_BACKGROUND_COLOR,
                            open: true,
                            items: this.categoryMenuItems
                        }
                    ];
                }, response => {
                });
            },
            graphDragHandler(startDay, endDay) {
                if (endDay.isAfter(moment().add(-1, 'days'))) {
                    return;
                }
                if (this.zoomLevel >= 3) {
                    if (this.startDay.format('MM-DD-YY') !== startDay.format('MM-DD-YY')) {
                        this.startDay = startDay;
                        this.endDay = endDay;
                        this.setGraphData(this.graphWeeklyDataFromBackend);
                    }
                }
                else {
                    if (this.startDay.format('MM-DD-YY') !== startDay.format('MM-DD-YY')) {
                        this.startDay = startDay;
                        this.endDay = endDay;
                        this.setGraphData(this.graphDataFromBackend);
                    }
                }
            },
            adjustShownDates() {
                if (this.zoomLevel === 1) {
                    this.startDay = moment().add((-1 * this.zoomLevel1DayCount), 'days');
                    this.endDay = moment().add((-1), 'days');
                } else if (this.zoomLevel === 2) {
                    this.startDay = moment().add((-1 * this.zoomLevel2DayCount), 'days');
                    this.endDay = moment().add((-1), 'days');
                } else if (this.zoomLevel === 3) {
                    let computeEndDay = moment().startOf('isoWeek');
                    this.startDay = moment(computeEndDay).add((-1 * this.zoomLevel3WeekCount), 'weeks');
                    this.endDay = computeEndDay;
                } else if (this.zoomLevel === 4) {
                    let computeEndDay = moment().startOf('isoWeek');
                    this.endDay = computeEndDay;
                    this.startDay = moment(this.endDay).add((-1 * this.zoomLevel4WeekCount), 'weeks');
                } else if (this.zoomLevel === 5) {
                    let computeEndDay = moment().startOf('isoWeek');
                    this.endDay = computeEndDay;
                    this.startDay = moment(this.endDay).add((-1 * this.zoomLevel5WeekCount), 'weeks');
                }
            },
            dateEqualityCompare(tempDay) {
                return (tempDay.format('MM-DD-YY') === this.startDay.format('MM-DD-YY')) || (tempDay.format('MM-DD-YY') === this.endDay.format('MM-DD-YY'));
            },
            setGraphData(data) {
                // this.dataForGraph = [];
                let tempDataForGraph = [];
                this.fetchData = false;
                this.loading = true;
                if (this.selectedItemEnum === 0) {
                    for (let i = 0; i < data.length; i = i + TOTAL_FEED_COUNT) {
                        let tempDay = moment(data[i].date);
                        if (this.dateEqualityCompare(tempDay) || tempDay.isBetween(this.startDay, this.endDay)) {
                            for (let j = 0; j < constants.risk_group_array.length; j++) {
                                let oneRiskGroupSlice = data.slice(i, i + TOTAL_FEED_COUNT).filter(oneData => oneData.threat_risk_group_enum_no === constants.risk_group_array[j].enum_no);
                                let totalCountForOneGroup = oneRiskGroupSlice.reduce((sum, {count}) => sum + parseInt(count), 0);
                                let radius = 0;
                                if (this.zoomLevel >= 3) {
                                    radius = this.getWeeklyLogarithmicRadius(totalCountForOneGroup);
                                }
                                else {
                                    radius = this.getLogarithmicRadius(totalCountForOneGroup);
                                }
                                let obj = {
                                    label: totalCountForOneGroup,
                                    data: [{
                                        x: tempDay.format(),
                                        y: constants.risk_group_array[j].enum_no,
                                        r: radius
                                    }],
                                    backgroundColor: "rgba(255,71,58,0.8)",
                                    hoverBackgroundColor: "rgba(255,71,58,0.7)",
                                    hoverRadius: 1
                                };
                                tempDataForGraph.push(obj);
                            }
                        }
                    }
                } else {
                    let oneRiskGroupSlice = data.filter(oneData => oneData.threat_risk_group_enum_no === this.selectedItemEnum);
                    let sub_risk_array = constants.risk_group_array.filter(oneData => oneData.enum_no === this.selectedItemEnum)[0].sub_risks;
                    oneRiskGroupSlice.map(oneData => {
                        if (this.dateEqualityCompare(moment(oneData.date)) || moment(oneData.date).isBetween(this.startDay, this.endDay)) {
                            let radius = 0;
                            if (this.zoomLevel >= 3) {
                                radius = this.getWeeklyLogarithmicRadius(parseInt(oneData.count));
                            }
                            else {
                                radius = this.getLogarithmicRadius(parseInt(oneData.count));
                            }
                            let obj = {
                                label: parseInt(oneData.count),
                                data: [{
                                    x: moment(oneData.date).format(),
                                    y: sub_risk_array.filter(oneSubrisk => oneSubrisk.enum_no === oneData.threat_enum_no)[0].graph_value,
                                    r: radius
                                }],
                                backgroundColor: "rgba(255,71,58,0.8)",
                                hoverBackgroundColor: "rgba(255,71,58,0.7)",
                                hoverRadius: 1
                            };
                            tempDataForGraph.push(obj)
                        }
                    });
                }
                this.dataForGraph = tempDataForGraph;
                this.fetchData = true;
                this.loading = false;
            },
            getBaseLog(base, count) {
                if (count === 1) {
                    return 1;
                }
                return Math.log(count) / Math.log(base)
            },
            getLogarithmicRadius(count) {
                return count ? this.getBaseLog(this.logarithmicBase, count) : 0;
            },
            adjustMaxRadius() {
                let widthOfCanvas = document.getElementById("threat-timeline-menu").clientWidth * 6;
                if (this.zoomLevel === 1) {
                    this.maxRadius = widthOfCanvas / this.zoomLevel1DayCount;
                    if (this.selectedItemEnum === 4) {
                        this.maxRadius = (this.maxRadius / 2) + 4;
                    } else if (this.selectedItemEnum === 3) {
                        this.maxRadius = this.maxRadius / 4;
                    } else if (this.selectedItemEnum === 1) {
                        this.maxRadius = (this.maxRadius / 2) + 4;
                    } else if (!this.selectedItemEnum) {
                        this.maxRadius = (this.maxRadius / 3) + 2;
                    }
                } else if (this.zoomLevel === 2) {
                    this.maxRadius = (widthOfCanvas / this.zoomLevel2DayCount) - 4;
                    if (this.selectedItemEnum === 0) {
                        this.maxRadius = (this.maxRadius / 2) + 8;
                    } else if (this.selectedItemEnum === 3) {
                        this.maxRadius = (this.maxRadius / 2) + 4;
                    }
                } else if (this.zoomLevel === 3) {
                    this.maxRadius = (widthOfCanvas / this.zoomLevel3WeekCount) - 4;
                    if (this.selectedItemEnum === 3) {
                        this.maxRadius = (this.maxRadius / 4) - 2;
                    } else if (this.selectedItemEnum === 1) {
                        this.maxRadius = (this.maxRadius / 2);
                    } else if (this.selectedItemEnum === 4) {
                        this.maxRadius = (this.maxRadius / 2);
                    } else if (this.selectedItemEnum === 0) {
                        this.maxRadius = (this.maxRadius / 3) - 2;
                    }
                } else if (this.zoomLevel === 4) {
                    this.maxRadius = (widthOfCanvas / this.zoomLevel4WeekCount) - 4;
                    if (this.selectedItemEnum === 3){
                        this.maxRadius = (this.maxRadius / 2);
                    }   if (this.selectedItemEnum === 0){
                        this.maxRadius = (this.maxRadius / 2) + 4;
                    }
                }   else if (this.zoomLevel === 5){
                    this.maxRadius = (widthOfCanvas / this.zoomLevel5WeekCount) - 4;
                }
            },
            getMaxCountHelper(data) {
                this.adjustMaxRadius();
                let oneSlice = [];
                if (this.selectedItemEnum) {
                    oneSlice = data.filter(oneData => oneData.threat_risk_group_enum_no === this.selectedItemEnum);
                } else {
                    oneSlice = [...data];
                }
                let max = oneSlice.reduce((max, oneData) => oneData.count > max ? oneData.count : max, oneSlice[0].count);
                this.logarithmicBase = Math.pow(max, 1 / this.maxRadius);
            },
            getWeeklyMaxCountHelper(data) {
                this.adjustMaxRadius();
                let oneSlice = [];
                if (this.selectedItemEnum) {
                    oneSlice = data.filter(oneData => oneData.threat_risk_group_enum_no === this.selectedItemEnum);
                } else {
                    oneSlice = [...data];
                }
                let max = oneSlice.reduce((max, oneData) => parseInt(oneData.count) > max ? parseInt(oneData.count) : max, oneSlice[0].count);
                this.logarithmicBaseWeekly = Math.pow(max, 1 / this.maxRadius);
            },
            getWeeklyLogarithmicRadius(count) {
                return count ? this.getBaseLog(this.logarithmicBaseWeekly, count) : 0;
            },
            getGraphData() {
                let path = Constants.INTELLIGENCE_BACKEND_URL + '/dashboard/threat_timeline';
                let dailyBody = {
                    "group_by": "daily"
                };
                this.loading = true;
                this.$http.post(path, dailyBody).then(response => {
                    // this.getWeeklyGraphData();
                    this.graphDataFromBackend = response.body.data;
                    this.getMaxCountHelper(response.body.data);
                    this.setGraphData(response.body.data);
                    this.loading = false;
                }, response => {
                });
            },
            getWeeklyGraphData() {
                let path = Constants.INTELLIGENCE_BACKEND_URL + '/dashboard/threat_timeline';
                let weeklyBody = {
                    "group_by": "weekly"
                };
                // this.loading = true;
                this.$http.post(path, weeklyBody).then(response => {
                    this.graphWeeklyDataFromBackend = response.body.data;
                    this.getWeeklyMaxCountHelper(this.graphWeeklyDataFromBackend);
                })
            },
            onEnlargeClick() {
                this.enLargeClicked = this.getDashboardEnlargedItem;
                if (this.enLargeClicked != null) {
                    this.setMaximizeZoomLevelIndex(2);
                    this.setZoomLevelIndex(2);
                    this.$emit("enlargeClickedThreatTimeLine");
                    this.largeScreen = true;
                }
                else {
                    this.loading = true;
                    this.setMaximizeZoomLevelIndex(2);
                    this.setZoomLevelIndex(2);
                    this.$emit("enlargeClickedThreatTimeLine");
                    this.largeScreen = false;
                    setTimeout(this.timeOutToLoading, 3000)
                }
                this.setDashboardEnlargedItem(this.itemNumber);
            },
            timeOutToLoading() {
                this.loading = false;
            },
            changeZoomLevel(e) {
                if (e.deltaY < 0) {
                    if (this.zoomLevel === 5) {
                        this.zoomLevel = 5;
                        this.setZoomLevelIndex(5);
                    }
                    else {
                        this.zoomLevel++;
                        this.setZoomLevelIndex(this.zoomLevel);
                        this.adjustShownDates();
                    }
                }
                else {
                    if (this.zoomLevel === 1) {
                        this.zoomLevel = 1;
                        this.setZoomLevelIndex(1);
                    }
                    else {
                        this.zoomLevel--;
                        this.setZoomLevelIndex(this.zoomLevel);
                        this.adjustShownDates();
                    }
                }
            },
            checkLargePage() {
                this.enLargeClicked = this.getDashboardEnlargedItem;
                if (this.enLargeClicked == this.itemNumber) {
                    this.$emit("enlargeClickedThreatTimeLine");
                    this.largeScreen = false;
                }
            },
            setZoomLevel() {
                this.setZoomLevelIndex(2);
            },
            ...mapActions([
                "setDashboardEnlargedItem",
                "setZoomLevelIndex",
                "setMaximizeZoomLevelIndex"
            ])
        },
        computed: {
            ...mapGetters([
                "getDashboardEnlargedItem",
                "getZoomLevelIndex",
                "getMaximizeZoomLevelIndex"
            ])
        },
        watch: {
            zoomLevel: function () {
                if (this.zoomLevel == 1) {
                    this.getMaxCountHelper(this.graphDataFromBackend);
                    this.getCategoryList();
                    this.setGraphData(this.graphDataFromBackend);
                    this.graphLabel = '14 days';
                } else if (this.zoomLevel == 2) {
                    this.getMaxCountHelper(this.graphDataFromBackend);
                    this.getCategoryList();
                    this.setGraphData(this.graphDataFromBackend);
                    this.graphLabel = '30 days';
                } else if (this.zoomLevel == 3) {
                    this.getWeeklyMaxCountHelper(this.graphWeeklyDataFromBackend);
                    this.getCategoryList();
                    this.setGraphData(this.graphWeeklyDataFromBackend);
                    this.graphLabel = '12 weeks';
                } else if (this.zoomLevel == 4) {
                    this.getWeeklyMaxCountHelper(this.graphWeeklyDataFromBackend);
                    this.getCategoryList();
                    this.setGraphData(this.graphWeeklyDataFromBackend);
                    this.graphLabel = '24 weeks';
                } else if (this.zoomLevel == 5) {
                    this.getWeeklyMaxCountHelper(this.graphWeeklyDataFromBackend);
                    this.getCategoryList();
                    this.setGraphData(this.graphWeeklyDataFromBackend);
                    this.graphLabel = '48 weeks';
                }
            }
        },
        mounted() {

        },
        beforeMount() {
            this.setZoomLevel();
            this.checkLargePage();
            this.adjustShownDates();
            this.getCategoryList();
            this.getWeeklyGraphData();
            this.getGraphData();
        }
    }
</script>

<style scoped>
    .graph-time-container {
        position: absolute;
        top: 60px;
        left: 90px;
        color: white;
        font-weight: bold;
    }
</style>



// WEBPACK FOOTER //
// src/pages/dashboard-page/threat-timeline/ThreatTimeLine.vue